import { createContext } from 'react';

export const initialValue = {
  state: {
    experience: 0,
  },
};
export const GlobalContext = createContext(initialValue);
